import React, { useEffect, useState } from "react";
import JsonRequest from "../components/jsonRequest";
import { useLocation } from "react-router-dom";

const ManualPage: React.FC = () => {
    const [data, setData] = useState<any>();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    let platform = queryParams.get('platform');

    useEffect(() => {
        getDetail();
    }, []);

    const getDetail = async () => {
        if (platform === 'ios') {
            platform = 'IOS';
        } else platform = 'ANDROID';
        JsonRequest.rawClient().get(`/common/user-agreement-privacy-policy`, {
            type: 'USER_AGREEMENT',
            deviceType: platform
        })
            .then((resp: any) => resp.json())
            .then(async ({ data }: any) => {
                setData(data);
            });
    };

    return (
        <div style={{ padding: '20px' }}>{data && <div dangerouslySetInnerHTML={{ __html: data }} />}</div>
    );
};

export default ManualPage;